import { S3_IMAGES_URL } from '../../../constants';

export const PLANETS = [
  {
    id: 1,
    src: `${S3_IMAGES_URL}planets_slider/planet-1.webp`,
    name: 'Planet No.1',
    text: 'First stay booking',
  },
  {
    id: 2,
    src: `${S3_IMAGES_URL}planets_slider/planet-2.webp`,
    name: 'Planet No.2',
    text: 'First flight order',
  },
  {
    id: 3,
    src: `${S3_IMAGES_URL}planets_slider/planet-3.webp`,
    name: 'Planet No.3',
    text: 'Visit five different countries',
  },
  {
    id: 4,
    src: `${S3_IMAGES_URL}planets_slider/planet-4.webp`,
    name: 'Planet No.4',
    text: 'Tenth app order',
  },
  {
    id: 5,
    src: `${S3_IMAGES_URL}planets_slider/planet-5.webp`,
    name: 'Planet No.5',
    text: 'First crypto booking',
  },
  {
    id: 6,
    src: `${S3_IMAGES_URL}planets_slider/planet-6.webp`,
    name: 'Planet No.6',
    text: 'First five installs with your link',
  },
  {
    id: 7,
    src: `${S3_IMAGES_URL}planets_slider/planet-7.webp`,
    name: 'Planet No.7',
    text: 'First app booking from your friend',
  },
  {
    id: 8,
    src: `${S3_IMAGES_URL}planets_slider/planet-8.webp`,
    name: 'Planet No.8',
    text: 'First crypto booking from your friend',
  },
];
